// StatsSection.js
import React from "react";
import "./StatsSection.css";

const statsData = [
  { icon: "📍", value: "140KM", label: "DISTANCE" },
  { icon: "⏱️", value: "3 - 6", label: "HOURS/DAY" },
  { icon: "⚡", value: "9", label: "DIFFICULTY (1-10)" },
];

const StatsSection = () => {
  return (
    <div
      className="stats-section"
      style={{ backgroundImage: `url("/background.jpg")` }}
    >
      <div className="stats-container">
        {statsData.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-icon">{stat.icon}</div>
            <div className="stat-value">{stat.value}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsSection;
